export default "__VITE_ASSET__DbLfH8xX__"